// extracted by mini-css-extract-plugin
module.exports = {"blue":"blue___2FrRj"};